import { FlowStep } from '../../flow-types'
import { INITIAL_INVALID_STEP_INDEX, INITIAL_NUM_VISITS } from './constants'

export const SINGLE_STEP_NAME = 'single'

export default function makeSingleStep(): FlowStep {
  return {
    name: SINGLE_STEP_NAME,
    title: 'Your donation', // TODO add translations,
    enabled: true,
    index: INITIAL_INVALID_STEP_INDEX,
    numVisits: INITIAL_NUM_VISITS,
    layout: 'one-column',
  }
}
